import React from 'react';
import ReactMarkdown from 'react-markdown';
import './index.css';
import AlertBar from '../../components/alertBar';
import Header from '../../components/header';
import Footer from '../../components/footer';
import Map from '../../components/map';
import CompaniesContact from '../../components/companiescontact';

export default (props, routerProps) => ({
  renderContactInfo(contactInfo) {
    let rendered = null;

    if (contactInfo) {
      rendered = <ReactMarkdown source={contactInfo} />;
    }

    return rendered;
  },

  render() {
    const renderedContactInfo = this.renderContactInfo(props.contactInfo);

    return (
      <div className="viewsContact">
        <Header {...props} />
        <AlertBar showLink={true} />

        <div className="padded-top-content">
          <div className="col-md-6 offset-md-3 p-0 m-t-big">
            <h5>Contact</h5>
            <h6 className="u-m-t-small">{renderedContactInfo}</h6>
          </div>

          <div className="col-md-6 offset-md-3 p-0 m-t-big">
            <h5>Airlines</h5>
            <CompaniesContact />
          </div>

          <div className="col-md-6 offset-md-3 p-0 m-t-big">
            <Map />
          </div>

          <div className="col-md-6 offset-md-3 p-0 m-t-big">
            <h5>Send us a message</h5>

            <form className="contact-form" action="https://www.aeroport-iasi.ro:5000/sendEmail" method="post" enctype="text/plain">
              <input className="form-control" placeholder="Name" name="name" />
              <input className="form-control" placeholder="Email" name="mail" />
              <textarea className="form-control" placeholder="Message" name="comment"></textarea>
              <input className="btn btn-info pull-right" type="submit" value="Send" />
            </form>

            <div className="clearfix"></div>
          </div>

          <Footer {...props} />
        </div>
      </div>
    );
  }
});



// WEBPACK FOOTER //
// ./src/views/contact/index.js